import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TitleType } from '@mri/types';

@Injectable({
  providedIn: 'root'
})
export class GlobalPageService {
  private _title$ = new Subject<string>();
  private _breadcrumb$ = new Subject<Array<TitleType>>();

  get title$() {
    return this._title$.asObservable();
  }

  get breadcrumb$() {
    return this._breadcrumb$.asObservable();
  }

  setTitle(title: string) {
    this._title$.next(title);
  }

  setBreadcrumb(breadcrumb: Array<TitleType>) {
    this._breadcrumb$.next(breadcrumb);
  }
  constructor() { }
}
